import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { getAdminTabPath } from '@/lib/adminNav';

const TABS = [
  { value: 'dashboard', labelKey: 'admin.dashboard', testId: 'admin-tab-dashboard' },
  { value: 'applications', labelKey: 'admin.applications', testId: 'admin-tab-applications' },
  { value: 'apartments', labelKey: 'admin.apartments', testId: 'admin-tab-apartments' },
  { value: 'visits', labelKey: 'admin.visits', testId: 'admin-tab-visits' },
  { value: 'property_managers', labelKey: 'admin.propertyManagers', testId: 'admin-tab-pms' },
  { value: 'users', labelKey: 'admin.users', testId: 'admin-tab-users' },
];

export default function AdminNavTabs({ activeTab }) {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="overflow-x-auto pb-1 mb-6" data-testid="admin-nav-tabs">
      <div
        role="tablist"
        className="bg-white border border-[#2B2B2B]/10 p-1 flex w-max min-w-full whitespace-nowrap rounded-md"
      >
        {TABS.map((tab) => {
          const isActive = activeTab === tab.value;
          return (
            <button
              key={tab.value}
              type="button"
              role="tab"
              aria-selected={isActive}
              data-testid={tab.testId}
              onClick={() => navigate(getAdminTabPath(tab.value))}
              className={`px-3 py-2 text-sm rounded-sm transition-colors ${
                isActive
                  ? 'bg-[#0B3D2E] text-white'
                  : 'text-[#2B2B2B] hover:bg-[#F5F3EF]'
              }`}
            >
              {t(tab.labelKey)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
